import { Box, Loader, Text } from '@wix/design-system'
import { useContent, usePageLoading } from '@wix/funnel-builder-lizard'
import React, { FC, useCallback } from 'react'

import { usePageLogger } from '../../bi/mfi'
import { CommonTemplateLayout } from '../reusable/CommonTemplate/CommonTemplateLayout'
import { WixStudioLogoWithBack } from '../reusable/WixStudioLogoWithBack'

type WixStudioLoaderProps = {
  title: string
}

export const WixStudioLoader: FC<WixStudioLoaderProps> = ({ title }) => {
  const [isPageLoading] = usePageLoading()
  const pageLogger = usePageLogger()
  const { content } = useContent<{ back: string }>()

  const handleBackClick = useCallback(() => {
    if (isPageLoading) {
      return
    }
    void pageLogger.back()

    window.history.back()
  }, [isPageLoading, pageLogger])
  return (
    <CommonTemplateLayout
      sidePanel={null}
      logo={<WixStudioLogoWithBack backButton={content.back} onBackClick={handleBackClick} />}
    >
      <Box direction="vertical" verticalAlign="middle" align="center" height="100vh">
        <Loader />
        <Text>{title}</Text>
      </Box>
    </CommonTemplateLayout>
  )
}
